import { render, staticRenderFns } from "./PricedStockCard.vue?vue&type=template&id=1a33fd60&scoped=true&"
import script from "./PricedStockCard.vue?vue&type=script&lang=js&"
export * from "./PricedStockCard.vue?vue&type=script&lang=js&"
import style0 from "./PricedStockCard.vue?vue&type=style&index=0&id=1a33fd60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a33fd60",
  null
  
)

export default component.exports